import { gql } from "@apollo/client";
import useData from "hooks/useData";
import { Cancel } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const VideoEncodingJobRequestsCancelDialog = makeConfirmActionDialog({
  mutationName: "videoEncodingJobRequestsCancel",
  fragment: "videoEncodingJobRequests { id cancelled }",
  paramName: "videoEncodingJobRequestIds",
  action: "Cancel Video Encoding Job Request",
  useButtonProps: ({ videoEncodingJobRequestIds }) => {
    const [data] = useData(
      gql`
        query VideoEncodingJobRequestToggleCanceldDialog($videoEncodingJobRequestIds: [ID!]!) {
          videoEncodingJobRequests(ids: $videoEncodingJobRequestIds) {
            id
            cancelled
          }
        }
      `,
      { videoEncodingJobRequestIds },
    );

    return {
      icon: <Cancel />,
      hidden: !data || !data.videoEncodingJobRequests.find((v) => !v.cancelled),
      content: "Cancel Video Encoding Job Request",
    };
  },
});
